export class AddToCartFormatModel {
    public constructor(
        public id: string = null,
        public quantity: number = 0
    ) {

    }
}
